import BaseApi from './BaseApi';

export type Information = {
  id: string;
  title: string;
  body: string;
  open_date: number;
  type: 'notice' | 'important';
  isRead: boolean;
};

/**
 * お知らせAPI。
 */
class NewsApi extends BaseApi {
  async get() {
    return await this.execute('news', {
      method: 'GET'
    }).then(({ result }) => result as Information[]);
  }
  async setRead(id: string) {
    return await this.execute('news', {
      method: 'PUT',
      body: { id }
    }).then(({ result }) => result as Information[]);
  }
}

export default NewsApi;
